import { dims, themeVars, pageNumberText } from "../../lib/pages";

export const Canvas = ({ settings, bodyRef, headerRef, footerRef, zoom, handlers, total }) => {
  const d = dims(settings);
  const pn = settings.pageNumbers;
  const [pv, ph] = pn.position.split("-");
  const pnEl = pn.enabled && (
    <div className="pn-preview" style={{ textAlign: ph }} data-testid="editor-page-number">{pageNumberText(pn.format, 1, total || 1)}</div>
  );
  const wm = settings.watermark;
  const line = "rgba(15,108,189,.3)";
  const guide = `repeating-linear-gradient(to bottom, transparent 0, transparent ${d.ch - 1}px, ${line} ${d.ch - 1}px, ${line} ${d.ch}px)`;
  return (
    <div className="canvas-scroll flex-1 overflow-auto bg-muted/60" data-testid="editor-canvas">
      <div className="py-4 px-2 sm:py-10 sm:px-6 flex justify-center w-max min-w-full" style={{ zoom }}>
        <div className="sheet editing" style={{ width: d.w, minHeight: d.h, ...themeVars(settings) }} data-testid="editor-sheet">
          {wm.text && (
            <div className="sheet-watermark" style={{ height: d.h, bottom: "auto", color: wm.color, opacity: wm.opacity }} data-testid="editor-watermark">
              <span style={{ fontSize: Math.round(d.w / 9) }}>{wm.text}</span>
            </div>
          )}
          <div className="hf-zone justify-end" style={{ height: d.mt, padding: `0 ${d.mr}px 10px ${d.ml}px`, overflow: d.mt < 24 ? "hidden" : undefined }}>
            {pv === "top" && pnEl}
            <div ref={headerRef} className="hf-edit lw-editable doc-content" contentEditable suppressContentEditableWarning data-placeholder="Header — click to type" data-testid="editor-header" />
          </div>
          <div ref={bodyRef} className="editor-body lw-editable doc-content" contentEditable suppressContentEditableWarning spellCheck
            data-testid="editor-body" style={{ margin: `0 ${d.mr}px 0 ${d.ml}px`, minHeight: d.ch, tabSize: settings.tabSize, backgroundImage: guide }} {...handlers} />
          <div className="hf-zone justify-start" style={{ height: d.mb, padding: `10px ${d.mr}px 0 ${d.ml}px`, overflow: d.mb < 24 ? "hidden" : undefined }}>
            <div ref={footerRef} className="hf-edit lw-editable doc-content" contentEditable suppressContentEditableWarning data-placeholder="Footer — click to type" data-testid="editor-footer" />
            {pv === "bottom" && pnEl}
          </div>
        </div>
      </div>
    </div>
  );
};
